// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logistics-main-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 90vw;
  height: 100vh;
  background-color: oklch(98.4% 0.003 247.858);
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 1300;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

.logistics-body-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* gap: 16px; */
  /* flex: 1 0 0; */
  align-self: stretch;
  height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/logisticsDrawer/logisticsDrawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,4CAA4C;EAC5C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".logistics-main-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 90vw;\n  height: 100vh;\n  background-color: oklch(98.4% 0.003 247.858);\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  z-index: 1300;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out;\n}\n\n.logistics-body-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  /* gap: 16px; */\n  /* flex: 1 0 0; */\n  align-self: stretch;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
